import aHttp from '@/models/axiosConfig/aHttp';
import constants, { encryptedMarketplaceId } from '@/constants';
const {
  API_LIST: { EMTCSLP_EXTERNAL_APIGATEWAY_PROD }
} = constants;

const ORDER_START_TIME = '2018, 5, 1';
const urls = {
  getOrderListByCustomerId: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orderquery/getOrderListByCustomerId`, // Order number list
  getSignedReturnContractsOfCustomerPromise: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/getSignedReturnContractsOfCustomer`, // Gets all the backlist tables
  cancelItems: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/cancelItems `, // Cancel an order
  getOrderReturnDetails: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/getOrderReturnDetails`, // Check whether the item in the order is available for sale
  createReturnContract: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/createReturnContract`, // Create an aftermarket order agreement
  setReturnResolution: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/setReturnResolution`, // Calculate the amount after sale
  setReturnTransportation: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/setReturnTransportation`, // Pick up at home
  setReturnTransportationAndSign: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/setReturnTransportationAndSign`, // Pick up at home offshore order Starting Call
  setReturnContractState: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/setReturnContractState`, // Confirm the return
  getShipmentInfo: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orderquery/getShipmentInfo`, // Get express logistics information
  getOrderListByPurchaseId: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orderquery/getOrderListByPurchaseId`, // Get order number based on PurchaseId
  getCandidates: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/review/candidates`, // Get the asin list to be commented on
  getCustomerReview: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/review/customerReview`, // Get the commented ASIN list
  saveOrUpdateReview: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/review/saveOrUpdate`, // Save or update comments
  withdrawReview: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/review/withdrawReview`, // Delete Comment
  getOrderDetailInfo: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orderquery/getOrderDetailInfoV1`, // Get order details
  getBatchOrderBasicDetailInfo: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orderquery/getBatchOrderBasicDetailInfo` // Get order orderList
};
export const getOrderListByCustomerId = (params = {}) => {
  const currentDate = new Date();
  const endTimeStamp = currentDate.getTime();
  const startDate = new Date(ORDER_START_TIME);
  const startTimeStamp = startDate.getTime();
  params = {
    startDate: startTimeStamp,
    endDate: endTimeStamp,
    pageIndex: 1,
    orderNumOnePage: 99999,
    ...params
  };
  return aHttp.get(urls.getOrderListByCustomerId, params);
};
export const cancelItems = params => aHttp.post(urls.cancelItems, params);
export const getSignedReturnContractsOfCustomerPromise = (
  params = { clientName: 'YourOrders' }
) => {
  return aHttp.post(urls.getSignedReturnContractsOfCustomerPromise, params);
};
export const getOrderDetailInfo = params =>
  aHttp.get(urls.getOrderDetailInfo, params);
export const getOrderReturnDetails = params =>
  aHttp.post(urls.getOrderReturnDetails, params);
export const createReturnContract = params =>
  aHttp.post(urls.createReturnContract, params);
export const setReturnResolution = params =>
  aHttp.post(urls.setReturnResolution, params);
export const setReturnTransportation = params =>
  aHttp.post(urls.setReturnTransportation, params);
export const setReturnTransportationAndSign = params =>
  aHttp.post(urls.setReturnTransportationAndSign, params);
export const setReturnContractState = params =>
  aHttp.post(urls.setReturnContractState, params);
export const getShipmentInfo = params =>
  aHttp.get(urls.getShipmentInfo, params);
export const getOrderListByPurchaseId = params =>
  aHttp.get(urls.getOrderListByPurchaseId, params);
export const getCandidates = params =>
  aHttp.get(urls.getCandidates, {
    ...params,
    marketplaceId: encryptedMarketplaceId
  });
export const getCustomerReview = params =>
  aHttp.get(urls.getCustomerReview, {
    ...params,
    marketplaceId: encryptedMarketplaceId
  });
export const saveOrUpdateReview = params =>
  aHttp.post(urls.saveOrUpdateReview, {
    ...params,
    marketplaceId: encryptedMarketplaceId
  });
export const withdrawReview = params =>
  aHttp.post(urls.withdrawReview, {
    ...params,
    marketplaceId: encryptedMarketplaceId
  });
export const getBatchOrderBasicDetailInfo = data =>
  aHttp.get(`${urls.getBatchOrderBasicDetailInfo}?${data}`);
